import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {NavController, NavParams, TextInput, ViewController} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";
import {ENUM, TAction} from "../../../app/enum";
import {CONFIG} from "../../../app/config";
import {DataService} from '../../../providers/data-service';
import {StorageService} from '../../../providers/storage-service';
import {PaymentRepo} from '../../../repositories/payment-repo';

@Component({
    selector: 'page-regedit-menu',
    templateUrl: 'regedit-menu.html',
    providers: [PaymentRepo]
})
export class RegeditMenuPage {
    
    ENUM: any = ENUM;
    config: any = CONFIG;

    akkjson = (window as any).handappMainInstance.appjson;
    monitorAuth = this.akkjson.hotwork;

    settingPage: number = 0;
    requestErro: any;
    paybookSair: any;
    tecladoLock = true;
    tecladoHoip = '';
    tecladoSize = 80;

    devicerKtoy = (CONFIG.data.device.DevicerNome == 'K2' || CONFIG.data.device.DevicerNome == 'K2_MINI');


    @ViewChild('inputHoip') inputHoip: TextInput;

    
    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                public dataService: DataService, public storageService: StorageService,
                public paymentRepo: PaymentRepo,
                public util: Util) {

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Regedit', '/regedit-menu');

        //Hide Support Button Fab
        (window as any).handappMainInstance.supportShow = false;

        this.tecladoHoip = (this.monitorAuth ? this.monitorAuth.Hotspot.HotspotHoip : '');

        //#ScreenHeight
        this.tecladoSize = (window.innerHeight < 700 ? 60 : 80);

    }

    ionViewDidLoad() {
        
    }

    ionViewDidEnter() {

        //ERRO VERIFICAR ACHO QUE ISSO SOBRE A BARRA DOS BOTOES DO ANDROID NO TOTEM! - Procurar por "display": (manifest.json)
        //this.util.stylesBarOnoff(false);
        //this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        return 'Setting';

    }

    tecladoOkey(btn) {
        
        if (btn == 'ok') {
            //ENTRAR
        }

        else if (btn == 'cancel') {
            this.dismiss();
        }

        else if (btn == 'erase') {
            this.tecladoHoip = '';
        }

        else if (btn == 'left-thin') {
            this.tecladoHoip = this.tecladoHoip.slice(0, this.tecladoHoip.length-1);
        }

        else if (btn == 'dot') {
            let array = this.tecladoHoip.split('.');
            let value = parseInt(array[array.length-1] + btn) || 0;
            let bool = (value > 0 && value < 255 && array.length < 4) || (array[array.length-1].length == 1);
            if (bool) this.tecladoHoip = this.tecladoHoip + '.';
        }

        else {
            let array = this.tecladoHoip.split('.');
            let value = parseInt(array[array.length-1] + btn) || 0;
            let first = (array[array.length-1] == '0');
            let zero = (array.length > 1 && array[array.length-1] == '' && btn == '0');
            let bool = (value > 0 && value < 255 && array.length < 5 && !zero && !first) || (zero);
            if (bool) this.tecladoHoip = this.tecladoHoip + btn + '';
        }

    }

    inverteLock() {

        this.tecladoLock = !this.tecladoLock;

    }


    hotspotLoad() {

        if (!this.tecladoHoip) {
            this.akkjson.hotwork = null;
            this.monitorAuth = null;

            this.storageService.set('MONITOR-AUTH', null, true).subscribe();
            this.dataService.set('MONITOR-AUTH', null);
            this.dismiss();
            return;
        }

        let onSpot = (data) => {
            this.akkjson.hotwork = {Action: data.Action, Hotspot: data.Hotspot};
            this.monitorAuth = this.akkjson.hotwork;
            //this.tecladoHoip = data.Hotspot.HotspotHoip;

            //RegeditMenu
            this.storageService.set('MONITOR-AUTH', this.akkjson.hotwork, true).subscribe();
            this.dataService.set('MONITOR-AUTH', this.akkjson.hotwork);

            //this.settingZera();
            //this.settingNome();
            //this.settingCnpj();
            //this.settingHead();
            //this.settingBody();
            //this.settingLogo();
            //this.prepareLogo();

            this.dismiss();
        }

        let loading = this.util.loadingDots();
        loading.present();

        this.util.monitorDesk(true, 'DESK-Started', 0, '', TAction.acSpot, null, null, this.tecladoHoip)
        .finally(() => loading.dismiss())
        .subscribe(
            data => onSpot(data),
            erro => this.util.alertResult(erro, () => this.tecladoOkey('erase'))
        );

    }

    devicerIpad() {

        let devicerIpad = (this.akkjson.devicerIpad ? true : null);
        
        this.storageService.set('DEVICER-IPAD', devicerIpad, true).subscribe();
        this.dataService.set('DEVICER-IPAD', devicerIpad);
        
        window.location.reload();
        
    }



    dismiss() {

        this.viewCtrl.dismiss();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/regedit-menu/regedit-menu.ts